import get from 'lodash.get';

const getVisibilityStatus = (rootState) => get(rootState, 'ui.mainMenu.mainMenu.visibility', {});

export default getVisibilityStatus;
